import type {Context} from '../types';

const targetedNodeTypes: Record<string, boolean> = {
  Block: true,
  Heading: true,
  SearchResultEmpty: true,
  SearchResultWrapper: true,
  SearchResultList: true,
  SearchResultItem: true,
  SliderSlide: true,
  TabsContent: true,
  TabsMenu: true,
  TabsPane: true,
  NavbarButton: true,
  NavbarContainer: true,
  NavbarMenu: true,
  NavbarWrapper: true,
  DropdownList: true,
  DropdownToggle: true,
  DropdownWrapper: true,
  List: true,
  RichText: true,
  Container: true,
  Row: true,
  Column: true,
  Section: true,
  DynamoWrapper: true,
  DynamoList: true,
  DynamoEmpty: true,
  CommerceAddToCartWrapper: true,
  CommerceAddToCartError: true,
  CommerceAddToCartErrorText: true,
  CommerceAddToCartOutOfStock: true,
  CommerceCartWrapper: true,
  CommerceCartHeading: true,
  CommerceCartList: true,
  CommerceCartProductName: true,
  CommerceCartOrderValue: true,
  CommerceCartErrorText: true,
  BackgroundVideoWrapper: true,
};

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {type} = jsonNode;

  const needed = Boolean(
    type && targetedNodeTypes[type] && (!jsonNode.data || !jsonNode.data.tag)
  );

  return {
    needed,
    logData: {
      msg: `${type} is missing a required \`node.data.tag\``,
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.data = jsonNode.data || {};
      jsonNode.data.tag = jsonNode.tag || 'div';
    },
  };
};
